import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../Shared/Icon/Icon'

function EmptyDesignerSection({ title }) {
  return (
    <div className="projects-empty__usp">
      <div className="container-fixed">
        <div className="row">
          <div className="col-12">
            <h4 className="heading-24">{title}</h4>
          </div>
          <div className="col-12 col-sm-6 col-md-3 projects-empty__usp-block">
            <Icon type={['fal', 'usd-circle']} size="4x" color="green-dark" />
            <h5 className="heading-18">Highest Earning Rate</h5>
            <p>CGTrader 3D Projects have the lowest fee in the industry – 5% flat.</p>
          </div>
          <div className="col-12 col-sm-6 col-md-3 projects-empty__usp-block">
            <Icon type={['fal', 'shield-check']} size="4x" color="green-dark" />
            <h5 className="heading-18">Security & Assurance</h5>
            <p>The payment is reserved and kept in escrow until a Project is finished.</p>
          </div>
          <div className="col-12 col-sm-6 col-md-3 projects-empty__usp-block">
            <Icon type={['fal', 'briefcase']} size="4x" color="green-dark" />
            <h5 className="heading-18">Bring your business with you</h5>
            <p>Use the 'Invite a client' function to start projects with no effort on your client's part.</p>
          </div>
          <div className="col-12 col-sm-6 col-md-3 projects-empty__usp-block">
            <Icon type={['fal', 'users']} size="4x" color="green-dark" />
            <h5 className="heading-18">Make a name for yourself</h5>
            <p>Gain more reputation and be in demand by successfully completing 3D Projects.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

EmptyDesignerSection.propTypes = {
  title: PropTypes.string.isRequired,
}

export default EmptyDesignerSection
